import React from 'react';

import Page from './Page';
import Error from './Error';
import forbiddenErrorIcon from '../assets/images/icon-forbidden-error.svg';

const AdministrationPage = ({ isAdministrator, children }) => {
  if (!isAdministrator) {
    return (
      <Error
        title="Sei entrato in un giardino segreto..."
        message="Pare che tu non possa vedere cosa c'è dentro."
        icon={forbiddenErrorIcon} />
    );
  }

  return (
    <Page>
      { children }
    </Page>
  );
};

export default AdministrationPage;